const TENANT_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

export function isValidTenantId(value: string) {
  const tenantId = value.trim();

  return (
    tenantId.length > 0 &&
    TENANT_ID_PATTERN.test(tenantId) &&
    encodeURIComponent(tenantId) === tenantId
  );
}

export function getValidTenantIds(tenantIds: string[]) {
  return [
    ...new Set(
      tenantIds
        .map((tenantId) => tenantId.trim())
        .filter((tenantId) => isValidTenantId(tenantId)),
    ),
  ];
}

export function getFirstAccessibleTenantId(tenantIds: string[]) {
  return getValidTenantIds(tenantIds)[0] ?? null;
}

export function canAccessTenantId(tenantId: string, tenantIds: string[]) {
  const normalizedTenantId = tenantId.trim();

  return (
    isValidTenantId(normalizedTenantId) &&
    getValidTenantIds(tenantIds).includes(normalizedTenantId)
  );
}

export function createTenantHref(tenantId: string) {
  return `/${encodeURIComponent(tenantId)}`;
}
